import styled, { css } from 'styled-components'

export const ArchiveButton = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: auto;

    svg {
      margin-right: 8px;
      fill: ${theme.colors.black};
    }
  `}
`
